import React from 'react';
export function HeroSection() {
  return <section className="px-5 pt-8 pb-8 max-w-[640px] mx-auto text-center" data-id="element-87">
      <div className="text-[22px] font-black tracking-tight mb-5" data-id="element-88">
        CÓDIGO<span className="text-[var(--red2)]" data-id="element-89">ROJO</span>
      </div>

      <span className="inline-block bg-[var(--red)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-5 uppercase" data-id="element-90">
        SISTEMA DE DETECCIÓN · SOLO PARA ELLA
      </span>

      <h1 className="text-[clamp(28px,7vw,42px)] font-extrabold leading-tight mb-9" data-id="element-91">
        Detecta a un hombre inconsistente en 15 minutos
        <br data-id="element-92" />
        <span className="text-[var(--muted)] text-[clamp(20px,5vw,28px)]" data-id="element-93">
          (antes de la primera cita)
        </span>
      </h1>

      <div className="h-[3px] w-[50px] bg-[var(--accent)] mx-auto my-4" data-id="element-94" />

      <p className="text-white text-[17px] leading-relaxed my-4 max-w-[520px] mx-auto" data-id="element-95">
        Deja de adivinar y empieza a saber. Usa el Escáner Digital para filtrar
        desde tu sofá y el Radar Invisible para obtener una respuesta binaria en
        tus citas.
      </p>

      <img src="https://cdn.magicpatterns.com/uploads/1mkcCx5qgG7GVWdRXtnRYk/IMG_8815.png" alt="Código Rojo — Sistema de Detección" className="w-full max-w-[420px] rounded-2xl mx-auto mt-4 mb-6 block" data-id="element-96" />

      <a href="https://www.auditoriacodigorojo.decidirconclaridad.com/checkouts/cn/hWNBZNo3vNtVEtV4LiscjXus/es-us" target="_blank" rel="noopener noreferrer" className="block bg-[var(--red2)] text-white text-center py-4 px-6 rounded-xl font-bold text-[13px] sm:text-[15px] tracking-wider max-w-[420px] mx-auto hover:bg-[#a82040] transition-colors" data-id="element-97">
        OBTENER MI ACCESO INSTANTÁNEO — $17 →
      </a>

      <p className="text-[var(--muted)] text-xs mt-3" data-id="element-98">
        Evita meses de confusión por menos de lo que cuesta un cocktail.
      </p>
    </section>;
}